import { PRESETS } from "@/lib/dateRanges";
import { fmtDate } from "@/lib/format";

export const DashFilters = ({ preset, setPreset, custom, setCustom, range, repId, setRepId, source, setSource, reps, sources }) => (
  <div className="flex flex-col gap-3 rounded-2xl border border-slate-800 bg-slate-900 p-4 lg:flex-row lg:items-end" data-testid="dash-filters">
    <label className="block lg:w-48">
      <span className="field-label">Date range</span>
      <select data-testid="dash-filter-preset" value={preset} onChange={(e) => setPreset(e.target.value)} className="inp">
        {PRESETS.map((p) => <option key={p.key} value={p.key}>{p.label}</option>)}
      </select>
    </label>
    {preset === "custom" && (
      <div className="grid grid-cols-2 gap-2">
        <label className="block"><span className="field-label">From</span>
          <input type="date" data-testid="dash-filter-from" value={custom.from} onChange={(e) => setCustom((c) => ({ ...c, from: e.target.value }))} className="inp" />
        </label>
        <label className="block"><span className="field-label">To</span>
          <input type="date" data-testid="dash-filter-to" value={custom.to} onChange={(e) => setCustom((c) => ({ ...c, to: e.target.value }))} className="inp" />
        </label>
      </div>
    )}
    <label className="block lg:w-52">
      <span className="field-label">Rep</span>
      <select data-testid="dash-filter-rep" value={repId} onChange={(e) => setRepId(e.target.value)} className="inp">
        <option value="">All reps</option>
        {reps.map((r) => <option key={r.id} value={r.id}>{`${r.name} · ${r.role}${r.active ? "" : " (inactive)"}`}</option>)}
      </select>
    </label>
    <label className="block lg:w-44">
      <span className="field-label">Source</span>
      <select data-testid="dash-filter-source" value={source} onChange={(e) => setSource(e.target.value)} className="inp">
        <option value="">All sources</option>
        {sources.map((s) => <option key={s} value={s}>{s}</option>)}
      </select>
    </label>
    <p data-testid="dash-range-label" className="font-mono text-xs text-slate-400 lg:ml-auto lg:pb-3">
      {range.from || range.to ? `${fmtDate(range.from)} → ${fmtDate(range.to)}` : "All Time"}
    </p>
  </div>
);
